
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BlogCategory } from "@/types/blogPost";
import { CategoryPreview } from "./CategoryPreview";

interface CategoryFormProps {
  editingCategory: BlogCategory | null;
  onSubmit: (formData: CategoryFormData) => void;
  onCancel: () => void;
}

export interface CategoryFormData {
  name: string;
  color_hex: string;
  border_color_hex: string;
  text_color_hex: string;
}

export function CategoryForm({ editingCategory, onSubmit, onCancel }: CategoryFormProps) {
  const [formData, setFormData] = useState<CategoryFormData>({
    name: editingCategory?.name || "",
    color_hex: editingCategory?.color_hex || "#6B7280",
    border_color_hex: editingCategory?.border_color_hex || "#D1D5DB",
    text_color_hex: editingCategory?.text_color_hex || "#000000"
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          {editingCategory ? "Editar Categoria" : "Nova Categoria"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name">Nome da Categoria</Label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div>
              <Label htmlFor="color_hex">Cor de Fundo</Label>
              <div className="flex gap-2">
                <Input
                  id="color_hex"
                  type="color"
                  value={formData.color_hex}
                  onChange={(e) => setFormData({ ...formData, color_hex: e.target.value })}
                  className="w-16 h-10 p-1"
                />
                <Input
                  value={formData.color_hex}
                  onChange={(e) => setFormData({ ...formData, color_hex: e.target.value })}
                  placeholder="#6B7280"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="border_color_hex">Cor da Borda</Label>
              <div className="flex gap-2">
                <Input
                  id="border_color_hex"
                  type="color"
                  value={formData.border_color_hex}
                  onChange={(e) => setFormData({ ...formData, border_color_hex: e.target.value })}
                  className="w-16 h-10 p-1"
                />
                <Input
                  value={formData.border_color_hex}
                  onChange={(e) => setFormData({ ...formData, border_color_hex: e.target.value })}
                  placeholder="#D1D5DB"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="text_color_hex">Cor do Texto</Label>
              <div className="flex gap-2">
                <Input
                  id="text_color_hex"
                  type="color"
                  value={formData.text_color_hex}
                  onChange={(e) => setFormData({ ...formData, text_color_hex: e.target.value })}
                  className="w-16 h-10 p-1"
                />
                <Input
                  value={formData.text_color_hex}
                  onChange={(e) => setFormData({ ...formData, text_color_hex: e.target.value })}
                  placeholder="#000000"
                />
              </div>
            </div>
          </div>

          <CategoryPreview formData={formData} />

          <div className="flex gap-2">
            <Button type="submit">
              {editingCategory ? "Atualizar" : "Criar"} Categoria
            </Button>
            <Button type="button" variant="outline" onClick={onCancel}>
              Cancelar
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
